import type { Persona } from './session.types';

/**
 * Normalize the acl-svc persona vocabulary to the FE {@link Persona} set.
 *
 * The platform-operator persona is `PLATFORM_ADMIN` server-side (verified live
 * via `/auth/contexts`, ENT-88 seed) but `SA` everywhere in the FE (registry,
 * copy, selectors). Mapping at the REST boundary keeps one canonical vocabulary
 * inside the app and prevents `DASHBOARD_REGISTRY[persona]` lookups from missing.
 */
export function normalizePersona(raw: string): Persona {
  switch (raw) {
    case 'PLATFORM_ADMIN':
    case 'SA':
      return 'SA';
    case 'AGENCY':
    case 'CLIENT':
    case 'VENDOR':
    case 'WORKER':
      return raw;
    default:
      // Unknown personas pass through unchanged rather than silently becoming
      // SA — a future persona surfaces as a missing-panel bug, not a wrong one.
      return raw as Persona;
  }
}
